import { Mail, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useQuote } from "../lib/quoteContext";
import { SITE } from "../lib/site";

export default function Footer() {
  const { openQuote } = useQuote();
  return (
    <footer
      className="bg-[#0E1F44] text-white pt-14 pb-7"
      data-testid="site-footer"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 lg:gap-8 pb-10 border-b border-white/10">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-[20px] tracking-wide mb-1 text-white">
              TINA'S CLEANING COMPANY
            </h3>
            <p className="text-[11px] tracking-[0.18em] text-white/60 mb-4">
              {SITE.tagline}
            </p>
            <p className="text-[13px] text-white/70 leading-relaxed">
              Professional cleaning service for homes, rentals, and move-out
              spaces.
            </p>
          </div>

          {/* Contact */}
          <div>
            <p className="tc-eyebrow text-white/70 mb-4">Contact</p>
            <ul className="space-y-3 text-[13.5px] text-white/85">
              <li>
                <button
                  type="button"
                  onClick={() => openQuote()}
                  className="flex items-center gap-2.5 hover:text-white transition text-left"
                  data-testid="footer-email"
                >
                  <Mail className="w-4 h-4 text-[#9bbef0]" /> Email me
                </button>
              </li>
              <li>
                <a
                  href="https://wa.me/48572410075"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2.5 hover:text-white transition"
                  data-testid="footer-whatsapp"
                >
                  <MessageCircle className="w-4 h-4 text-[#9bbef0]" /> Text me on WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pt-6 text-[12.5px] text-white/55">
          <p>© 2026 Tina's Cleaning Company. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-white transition">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
